import { Message, Card, Header, Icon } from 'semantic-ui-react';
import type { FoodItem } from 'types';

/**
 * What the item detail pane accepts.
 *
 * Established from its single JSX call site, `../index.tsx:223`, which renders it
 * only when `clickedItem` is truthy — but this component nevertheless has its own
 * "Item Not found!" branch for an absent item, so `item` is optional.
 *
 * SUSPECTED DEFECT (line 14) — REPORTED, NOT FIXED. The absence branch guards
 * `itemData` but the header then reads `itemData.name.toUpperCase()` with no
 * guard on `name`. An item present but unnamed throws here, and `FoodItem.name`
 * is optional because the catalog feed genuinely omits it on some rows. Adding
 * `?.` would render an empty header instead of throwing, which is a behaviour
 * change; the assertion preserves the throw.
 */
type FoodItemDetailProps = {
  item?: FoodItem;
};

function FoodItemDetail(props: FoodItemDetailProps) {
  const itemData = props.item;

  return (
    <div>
      {!itemData && <Message warning header="Info" content="Item Not found!" />}

      {itemData && (
        <div>
          <Header as="h3" color="orange">
            <Icon name="food" color="green" />
            {/* Asserted, not guarded — see the SUSPECTED DEFECT note on the props
                type. `?.` here would render an empty header where the code
                currently throws. */}
            <Header.Content>{(itemData.name as string).toUpperCase()}</Header.Content>
          </Header>
          <Card
            fluid
            style={{
              padding: '2px',
              borderRadius: '20px',
              margin: '10px 1px 10px 0px',
              boxShadow: '2px 2px 5px 2px rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12)',
            }}
          >
            <Card.Content>
              <h4>Nutrition Facts</h4>
              {itemData.nutritionInfo
                ? Object.keys(itemData.nutritionInfo)
                    .map(function (k) {
                      return k + ':' + itemData.nutritionInfo![k];
                    })
                    .join(', ')
                : ''}
            </Card.Content>
            <Card.Content extra>DIET TYPE: {itemData.dietType ? itemData.dietType.join(',') : ''}</Card.Content>
            <Card.Content extra>CONTAINS: {itemData.contains ? itemData.contains.join(',') : ''}</Card.Content>
            <Card.Content extra>INGREDIENTS: {itemData.ingredients ? itemData.ingredients.join(',') : ''}</Card.Content>
            <Card.Content>
              <h4>PRICE: </h4>
              {itemData?.itemPrice ? parseFloat(itemData.itemPrice).toFixed(2) : ''}
            </Card.Content>
          </Card>
        </div>
      )}
    </div>
  );
}

export default FoodItemDetail;
